const CloseIconModalCMS = ({ size = 16, fill = '#4F4C4D' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_174_97087)">
      <path
        d="M9.6973 8.50025L14.8255 3.37209L15.883 2.31456C16.039 2.15855 16.039 1.90504 15.883 1.74904L14.7515 0.617504C14.5955 0.461499 14.3419 0.461499 14.1859 0.617504L8.00025 6.8032L1.81456 0.617004C1.65855 0.460999 1.40504 0.460999 1.24904 0.617004L0.117004 1.74854C-0.0390012 1.90454 -0.0390012 2.15805 0.117004 2.31406L6.3032 8.50025L0.117004 14.6859C-0.0390012 14.8419 -0.0390012 15.0955 0.117004 15.2515L1.24854 16.383C1.40454 16.539 1.65805 16.539 1.81406 16.383L8.00025 10.1973L13.1284 15.3255L14.1859 16.383C14.3419 16.539 14.5955 16.539 14.7515 16.383L15.883 15.2515C16.039 15.0955 16.039 14.8419 15.883 14.6859L9.6973 8.50025Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_174_97087">
        <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default CloseIconModalCMS;
